<template>
  <div class="download-overview">
    <div class="overview-board">
      <div class="board-center w1200">
        <div class="board-content">
          <div class="b-title">知链助手</div>
          <div class="b-subtitle">学员、讲师、商家都在用的客户端</div>
          <!-- <div class="b-desc">商家轻松管理课程、查看数据，讲师快捷直播授课，学员方便观看学习。</div> -->
          <router-link to="/" class="b-btn">下载知链助手</router-link>
        </div>
      </div>
    </div>
    <div class="overview-main">
      <div class="show-item show-item-even">
        <div class="item-content w1200">
          <div class="item-desc item-margin">
            <div class="d-title">已购课程支持APP端学习</div>
            <div class="d-main">
              学员可以用手机碎片化时间，随时随地方便学习已购课程。观看直播、录播，参与讨论提问。更好的学习体验，带来用户活跃度的提升
            </div>
          </div>
          <div class="item-pic">
            <img
              :src="
                require('@/assets/images/download2' + getImgSuffix + '.png')
              "
            />
          </div>
        </div>
      </div>
      <div class="show-item show-item-odd">
        <div class="item-content w1200">
          <div class="item-desc">
            <div class="d-title">手机实时查看店铺经营</div>
            <!-- <div class="d-subtitle">手机方便管理课程和查看数据</div> -->
            <div class="d-main">
              商家可以用手机，随时随地发布、上架、下架课程，编辑修改课程价格。可以进行用户、消息、评论和订单的管理。还能随时查询掌握店铺的经营数据和流水进账情况
            </div>
          </div>
          <div class="item-pic item-margin">
            <img
              :src="
                require('@/assets/images/download3' + getImgSuffix + '.png')
              "
            />
          </div>
        </div>
      </div>
      <div class="show-item show-item-even">
        <div class="item-content w1200">
          <div class="item-desc item-margin">
            <div class="d-title">一台手机就能开启直播</div>
            <!-- <div class="d-subtitle">随时随地一台手机搞定直播</div> -->
            <div class="d-main">
              讲师可以随时随地，方便快捷发起一场手机直播。支持语音直播、视频直播等多种形式，可选择横屏直播、竖屏直播的不同类型
            </div>
          </div>
          <div class="item-pic">
            <img
              :src="
                require('@/assets/images/download4' + getImgSuffix + '.png')
              "
            />
          </div>
        </div>
      </div>
      <div class="show-item show-item-odd">
        <div class="item-content w1200">
          <div class="item-desc">
            <div class="d-title">桌面端双向互动直播</div>
            <!-- <div class="d-subtitle">支持多人实时连麦互动直播课堂</div> -->
            <div class="d-main">
              最多支持17人实时连麦互动，同时最多支持1000人观看直播的多人互动课堂。搭配白板涂鸦、答题器、计时器、抢答器、随机选人等小工具，多种教学玩法更具趣味性
            </div>
          </div>
          <div class="item-pic item-margin">
            <img
              :src="
                require('@/assets/images/download5' + getImgSuffix + '.png')
              "
            />
          </div>
        </div>
      </div>
    </div>
    <v-free
      btnText="下载知链助手"
      title="点击下载知链助手"
      href=""
    ></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
export default {
  components: { 'v-free': Free },
  computed: {
    getImgSuffix() {
      return this.$store.state.sceneClassName === 'app' ? '_app' : '';
    }
  }
};
</script>

<style lang="scss">
.download-overview {
  .overview-board {
    padding-top: 216px;
    height: 640px;
    background: url('~@/assets/images/download1.png') center no-repeat;
    background-size: cover;
  }
  .overview-board .board-center {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .overview-board .board-content {
    width: 400px;
    color: #fff;
    font-weight: 500;
  }
  .overview-board .board-content .b-title {
    font-size: 64px;
    line-height: 72px;
  }
  .overview-board .board-content .b-subtitle {
    margin-top: 16px;
    font-size: 24px;
    line-height: 32px;
  }
  .overview-board .board-content .b-desc {
    margin-top: 24px;
    line-height: 28px;
    font-weight: 400;
  }
  .overview-board .board-content .b-btn {
    display: inline-block;
    cursor: pointer;
    margin-top: 72px;
    font-size: 16px;
    color: #1472ff;
    background: #fff;
    border-radius: 32px;
    padding: 10px 32px;
    line-height: 24px;
    -webkit-transition: 0.2s all ease;
    transition: 0.2s all ease;
  }
  .overview-board .board-content .b-btn:hover {
    color: #fff;
    background: #3d91ff;
  }
  .overview-board .board-content .b-btn:active {
    color: #fff;
    background: #1472ff;
  }
  .overview-board .board-bg img {
    display: block;
  }
  .overview-main .show-item-odd {
    background: #f5f9ff;
    .item-content {
      flex-direction: row-reverse;
    }
  }
  .overview-main .show-item-even {
    background: #fff;
  }
  .overview-main .item-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 692px;
  }
  .overview-main .item-content .item-desc {
    font-weight: 500;
    width: 468px;
    color: #333;
  }
  .overview-main .item-content .item-desc .d-title {
    font-size: 36px;
    line-height: 44px;
  }
  .overview-main .item-content .item-desc .d-main {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
  }
  .overview-main .item-content .item-pic img {
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
    width: 668px;
    height: 500px;
  }
}
.app .download-overview {
  .overview-board {
    padding: 0;
    font-weight: 600;
    color: #fff;
    text-align: center;
    background: url(~@/assets/images/download1_app.png) bottom no-repeat;
    background-size: cover;
    height: 8.64rem;
    .board-content {
      .b-title {
        padding-top: 1.6rem;
        font-size: 0.8rem;
        font-weight: 600;
        line-height: 0.96rem;
      }
      .b-subtitle {
        font-size: 0.32rem;
        font-weight: 500;
        margin-top: 0.16rem;
        line-height: 0.48rem;
      }
      .b-btn {
        margin-top: 0.64rem;
        background: #fff;
        color: #1472ff;
        font-size: 0.32rem;
        line-height: 0.48rem;
        padding: 0.16rem 0.64rem;
        border-radius: 0.88rem;
        font-weight: 500;
        border: none;
        outline: 0;
      }
    }
  }
  .overview-main {
    .show-item {
      text-align: center;
      padding: 1.28rem 0.32rem;
      .item-content {
        display: block;
        height: auto;
        .item-desc {
          width: auto;
        }
        .d-title {
          font-weight: 500;
          line-height: 0.72rem;
          font-size: 0.56rem;
        }
        .d-main {
          text-align: left;
          font-weight: 400;
          line-height: 0.44rem;
          font-size: 0.28rem;
          margin-top: 0.32rem;
          letter-spacing: -0.006rem;
          height: 1.76rem;
        }
        .item-pic {
          margin-top: 0.52rem;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>
